module.exports = __webpack_public_path__ + "static/media/circle-bg-full.483ce5d6.svg";